import GalleryStyle from '@/styles/pages/career/customize-career-page/_index.module.scss';
import { EditBannerIcon, useRef, useState, useEffect }  from '@/imports-files/pages/career/customize-career-page';
import UploadIcon from 'public/icons/career_icons/bigplus.svg';
import BlackCloseIcon from 'public/images/pages/career/benefit/icons/black_close.svg';
import CloseEyeIcon from 'public/icons/career_icons/eyeGalleryClose.svg';
import OpenEyeIcon from 'public/icons/career_icons/eyeGalleryOpen.svg';
import { isMobile, TabletView } from 'react-device-detect';
import AddMemberIcon from 'public/icons/career_icons/add-plus.svg';

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";

// import required modules
import { FreeMode, Autoplay, Mousewheel } from "swiper";


export function Gallery({formik, index, page_section, customizeCareerAction, isPreview, resetCareerPage}){
  const validItemLength = formik.values.page_sections_attributes[index].career_gallery_section_attributes.career_gallery_images_attributes.filter((x) => isPreview ? x.display == "show" : true).length
  const galleryTitle = useRef(formik.values.page_sections_attributes[index].career_gallery_section_attributes.title || page_section.title || '');
  const galleryDescription = useRef(formik.values.page_sections_attributes[index].career_gallery_section_attributes.description || page_section.description || '');
  const [addDisabled, setAddDisabled] = useState(false);
  const [flagForRender, setFlagForRender] = useState(0);
  const [flagForReRender, setFlagForReRender] = useState(0);
  function galleryEyeIcons(formik, index, gallery_index) {
    return formik.values.page_sections_attributes[index].career_gallery_section_attributes.career_gallery_images_attributes[gallery_index].display == 'show' ? <OpenEyeIcon/> : <CloseEyeIcon />
  }

  function showHideValue(formik, index, gallery_index){
    return formik.values.page_sections_attributes[index].career_gallery_section_attributes.career_gallery_images_attributes[gallery_index].display == 'show' ? 'hide' : 'show'
  }

  function galleryCount(formik, index) {
    let count = formik.values.page_sections_attributes[index].career_gallery_section_attributes.career_gallery_images_attributes.length

    if(TabletView && !isMobile){
      return count <= 2 ? 'swiper-center tablet' : ''
    }
    else if(isMobile){
      return count <= 1 ? 'swiper-center mobile' : ''
    }
    else {
      return count <= 2 ? 'swiper-center' : ''
    }
  }

  function cardLayout(formik, index){
    let item_length =  formik.values.page_sections_attributes[index].career_gallery_section_attributes.career_gallery_images_attributes.filter((x) => isPreview ? x.display == "show" : true).length
    if(typeof window !== 'undefined' && window.innerWidth >=768 && window.innerWidth <=1024){
      return GalleryStyle.Gallery__FourCardLayout
    }
    switch(true){
    case (item_length < 3):
      return GalleryStyle.Gallery__FourCardLayout
    case (item_length == 3):
      return GalleryStyle.Gallery__ThreeCardLayout
    case (item_length == 4):
      return GalleryStyle.Gallery__FourCardLayout
    case (item_length <= 6):
      return GalleryStyle.Gallery__SixCardLayout
    default:
      return GalleryStyle.Gallery__SixCardLayout
    }
  }

  function dummy_image_url(validItemLength){
    if(typeof window !== 'undefined' && window.innerWidth >=768 && window.innerWidth <=1024) return "/images/pages/career/gallery/dummy@512.png"
    return [1,2,4].includes(validItemLength) ? '/images/pages/career/gallery/dummy@768.png' : '/images/pages/career/gallery/dummy@512.png'
  }

  useEffect(() => {
    setFlagForReRender(Math.random()*10000)
  }, [resetCareerPage])

  return(
    <>
    <div className = {`${GalleryStyle.Gallery}`} id={page_section.uniq_reference}>
      <div className = {isPreview ? `${GalleryStyle.Gallery__PreviewContainer}`: `${GalleryStyle.Gallery__Container}`}>
      {<div className = {`${GalleryStyle.Gallery__FirstOption}`} style={customizeCareerAction.setBackgroundColor(formik, page_section.type)}>
        <div className = {`${GalleryStyle.Gallery__Content}`}>
          {!isPreview &&<div className = {`${GalleryStyle.Gallery__EditView}`}>
            <div className = {`${GalleryStyle.Gallery__Image} ${cardLayout(formik, index)}`}>
              {formik.values.page_sections_attributes[index].career_gallery_section_attributes.career_gallery_images_attributes.map((gallery_detail, gallery_index) => {
                return <div className = {`${GalleryStyle.Gallery__EditImage}`} key={`gallery_op1_${gallery_index}`}>
                  <img src = {gallery_detail.display == 'show' ? (gallery_detail.image_url || `/images/pages/career/gallery/page-gallery${gallery_index%6 +1}.png`) : dummy_image_url(validItemLength)}></img>
                  <div className = {`${GalleryStyle.Gallery__EditImage__UploadIcon}`}>
                    <input type="file" id="img" name="img"
                      accept = ".png, .jpg, .jpeg"
                      onChange   =   { (event) => {
                        customizeCareerAction.handleGalleryImage(event, formik, index, gallery_index)
                      }}
                      title = {customizeCareerAction.imageInfoContent('gallery_image')}
                     />
                   </div>
                   <div className = {`${GalleryStyle.Gallery__EditImage__EditIcon}`}>
                    {formik.values.page_sections_attributes[index].career_gallery_section_attributes.career_gallery_images_attributes.length > 2 && <div className = {`${GalleryStyle.Gallery__EditImage__UploadIcon}`}>
                      <BlackCloseIcon onClick={()=> {
                        customizeCareerAction.removeGalleryCard(formik, index, gallery_index)
                    }}  />
                    </div>}
                    {/*<div className = {`${GalleryStyle.Gallery__EditImage__CloseEyeIcon}`}
                      onClick={async(event) => {
                        let new_value = showHideValue(formik, index, gallery_index)
                        customizeCareerAction.showHideGalleryImage(formik, index, gallery_index, new_value)
                      }}
                      >
                      {galleryEyeIcons(formik, index, gallery_index)}
                    </div>*/}
                  </div>
                </div>
              })}
            </div>
          </div>}

          {/* Preview for desktop */}

           {isPreview && <div className = {`${GalleryStyle.Gallery__Preview}`}>
            <div className = {`${GalleryStyle.Gallery__Image} ${cardLayout(formik, index)} ${galleryCount(formik, index)}`}>
              {formik.values.page_sections_attributes[index].career_gallery_section_attributes.career_gallery_images_attributes.map((gallery_detail, gallery_index) => {
                return (gallery_detail.display == 'show' && <div className = {`${GalleryStyle.Gallery__EditImage}`} key={`gallery_op1_${gallery_index}`}>
                  <img src = {gallery_detail.image_url || `/images/pages/career/gallery/page-gallery${gallery_index%6 +1}.png`}></img>
                </div>)
              })}
            </div>
          </div>}

            {/* Preview and mobile
            {isPreview && <div className = {`${GalleryStyle.Gallery__Preview} ${GalleryStyle.Gallery__Preview__ShowInMobile}`}>
              <div className = {`${GalleryStyle.Gallery__MySwiper} GallerySwiper ${galleryCount(formik, index)}`}>
                  <Swiper
                    slidesPerView={2.4}
                    spaceBetween={10}
                    freeMode={true}
                    mousewheel={false}

                    modules={[FreeMode, Mousewheel]}
                    className="mySwiper"
                    >
                    <div className = {`${GalleryStyle.Gallery__Image} GallerySwiper ${galleryCount(formik, index)}`}>
                     {formik.values.page_sections_attributes[index].career_gallery_section_attributes.career_gallery_images_attributes.map((gallery_detail, gallery_index) => {
                        return (gallery_detail.display == 'show' && <SwiperSlide>
                          <img src = {gallery_detail.image_url || `/images/pages/career/gallery/page-gallery${gallery_index%4 +1}.jpg`}></img>
                            </SwiperSlide>)
                      })}
                    </div>
                  </Swiper>
              </div>
            </div>
            }*/}
        </div>

        {!isPreview && (formik.values.page_sections_attributes[index].career_gallery_section_attributes.career_gallery_images_attributes.length < 6) && <div className = {`${GalleryStyle.MeetTeam__AddNewMember} ${GalleryStyle.Gallery__AddNewMember}`}
            onClick={async(event) => {
              if(!addDisabled)
              {
                setAddDisabled(true)
                await customizeCareerAction.addGalleryCard(formik, index)
                setAddDisabled(false)
              }
            }}
          >
            <span> <span className = {`${GalleryStyle.MeetTeam__AddNewMember__Icon} ${GalleryStyle.Gallery__AddNewMember__Icon}`}><AddMemberIcon /></span> Add Image </span>
        </div>}
      </div>}
    {/*   {!isPreview && <div className = {`${GalleryStyle.Gallery__RemoveSection}`}> */}
    {/*     <span onClick={(event) => { */}
    {/*         customizeCareerAction.removeSection(formik, page_section) */}
    {/*       }}><img src ='/icons/career_icons/delete.svg'></img></span> */}
    {/* </div>} */}
  </div>
    </div>
    </>
  )
}

